import gql from "graphql-tag.macro";
import { getClient } from "Globals/api";
import { ONE_SECOND } from "Globals/constants/constants";

const deleteWorkflowMutation = gql`
    mutation DeleteWorkflow($payload: WorkflowIdQuery!) {
        DeleteWorkflow(workflowId: $payload) {
          id
        }
    }
`;

const createWorkflowMutation = gql`
    mutation CreateWorkflow($payload: WorkflowInputQuery!) {
        CreateWorkflow(workflow: $payload) {
          id
          stages
        }
    }
`;

const updateWorkflowMutation = gql`
    mutation UpdateWorkflow($payload: WorkflowInputQuery!) {
        UpdateWorkflow(workflow: $payload) {
          id
          stages
        }
    }
`;

const loadWorkflowQuery = gql`
    query LoadWorkflow($payload: WorkflowIdQuery!) {
        LoadWorkflow(workflowId: $payload) {
          id
          stages
        }
    }
`;

const loadAllWorkflowsQuery = gql`
    query LoadAllWorkflows {
        LoadAllWorkflows {
          id
          stages
        }
    }
`;

export const loadWorkflow = async workflowId => {
    const client = await getClient("workfloweditor");
    const { data } = await client.query({
        query: loadWorkflowQuery,
        variables: { payload: workflowId },
    });
    return data;
};

export const loadAllWorkflows = async () => {
    const client = await getClient("workfloweditor");
    const { data } = await client.query({
        query: loadAllWorkflowsQuery,
    });
    return data;
};


export const updateWorkflow = async workflow => {
    const client = await getClient("workfloweditor");
    const { data } = await client.mutate({
        mutation: updateWorkflowMutation,
        variables: { payload: { workflow } },
    });
    return data;
};

export const archiveWorkflow = async workflowId => {
    const client = await getClient("workfloweditor");
    const { data } = await client.mutate({
        mutation: updateWorkflowMutation,
        variables: { payload: { workflow: { id: workflowId, archived: true } } },
    });
    return data;
};

export const createWorkflow = async workflow => {
    const client = await getClient("workfloweditor");
    const { data } = await client.mutate({
        mutation: createWorkflowMutation,
        variables: { payload: workflow },
    });
    return data;
};

export const deleteWorkflow = async workflowId => {
    const client = await getClient("workfloweditor");
    const data = await client.mutate({
        mutation: deleteWorkflowMutation,
        variables: { payload: workflowId },
    });
    return data;

};
export const subscribeWorkflows = (subject, emit) => {
    const subscribeFn = subject.startsWith("id")
        ? () => loadWorkflow(subject)
        : loadAllWorkflows;
    setTimeout(async () => {
        emit(await subscribeFn());
    }, ONE_SECOND);
    return () => null;
};
